import(/* webpackMode: "eager" */ "/root/lms/LMS-cocopa-LX/src/apps/drone-school/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lms/LMS-cocopa-LX/src/apps/drone-school/components/templates/error-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lms/LMS-cocopa-LX/src/apps/drone-school/components/templates/suspense-loading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/root/lms/LMS-cocopa-LX/src/apps/drone-school/error-boundary.tsx");
;
import(/* webpackMode: "eager" */ "/root/lms/LMS-cocopa-LX/src/node_modules/.pnpm/next@14.2.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCAuthSessionReactProvider"] */ "/root/lms/LMS-cocopa-LX/src/packages/api/src/trpc/trpcAuthSessionReactProvider.tsx");
;
import(/* webpackMode: "eager" */ "/root/lms/LMS-cocopa-LX/src/packages/shared-ui/dist/index.css");
